import React, { useContext, useRef, useEffect } from 'react';
import { Box, styled } from '@mui/material';
import { DataContext } from '../context/DataProvider';
import { Scrollbars } from 'react-custom-scrollbars';

// Assuming you have a custom Editor component
import Editor from './Editor';

const Container = styled(Box)`
  background-color: #060606;
  height: 50vh;
 
  display: flex;
`;

const Code = () => {
  const { html, css, js, setHtml, setCss, setJs } = useContext(DataContext);
  const htmlScrollRef = useRef(null);
  const cssScrollRef = useRef(null);
  const jsScrollRef = useRef(null);

  useEffect(() => {
    if (htmlScrollRef.current) {
      htmlScrollRef.current.scrollToRight();
    }
    if (cssScrollRef.current) {
      cssScrollRef.current.scrollToRight();
    }
    if (jsScrollRef.current) {
      jsScrollRef.current.scrollToRight();
    }
  }, [html, css, js]);

  return (
   
    <Container>
       
      <Scrollbars
        ref={htmlScrollRef}
        style={{ flex: 1  }}
        renderThumbHorizontal={({ style }) => (
          <div style={{ ...style, backgroundColor: 'gray' }} />
        )}
        renderTrackHorizontal={({ style }) => (
          <div style={{ ...style, backgroundColor: '#262626' }} />
        )}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
      >
        <Editor
          language="xml"
          heading="HTML"
          value={html}
          onChange={setHtml}
          icon="/"
          color="#FF3C41"
        />
      </Scrollbars>
      <Scrollbars
        ref={cssScrollRef}
        style={{ flex: 1 }}
        renderThumbHorizontal={({ style }) => (
          <div style={{ ...style, backgroundColor: 'gray' }} />
        )}
        renderTrackHorizontal={({ style }) => (
          <div style={{ ...style, backgroundColor: '#262626' }} />
        )}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
      >
        <Editor
          language="css"
          heading="CSS"
          value={css}
          onChange={setCss}
          icon="*"
          color="#0EBEFF"
        />
      </Scrollbars>
      <Scrollbars
        ref={jsScrollRef}
        style={{ flex: 1 }}
        renderThumbHorizontal={({ style }) => (
          <div style={{ ...style, backgroundColor: 'gray' }} />
        )}
        renderTrackHorizontal={({ style }) => (
          <div style={{ ...style, backgroundColor: '#262626' }} />
        )}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
      >
        <Editor
          language="javascript"
          heading="JS"
          value={js}
          onChange={setJs}
          icon="( )"
          color="#FCD000"
        />
      </Scrollbars>
     
    </Container>
  );
};

export default Code;
